import { DatePicker, Form, Input } from "antd";
import apiFactory from "api";
import CustomPagination from "component/CustomPagination";
import { ButtonSolid } from "component/button";
import { INotification } from "constant/interfaces";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { notificationCategoryOptions } from "utils/notification";
import { StyledSelect } from "./style";

const { RangePicker } = DatePicker;

const Conveyed: React.FC = () => {
  const [notiData, setNotiData] = useState<INotification[]>([]);
  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [fetchLoading, setFetchLoading] = useState(false);

  const fetchData = useCallback(async () => {
    const { category, rangeValue, search } = form.getFieldsValue();

    let start_at;
    let end_at;

    if (rangeValue) {
      const [startDate, endDate] = rangeValue;
      start_at = dayjs(startDate).format("YYYY-MM-DD");
      end_at = dayjs(endDate).format("YYYY-MM-DD");
    }

    try {
      setFetchLoading(true);
      const data = await apiFactory.hsNoticeAdminApi.getPostList({
        page,
        per: perPage,
        notify_tab: 2,
        search,
        start_at,
        end_at,
        notification_category_id: category,
      });
      if (data) {
        setNotiData(data.notifications);
        setTotalItems(data.total_items);
      }
    } catch (error) {
      //
    } finally {
      setFetchLoading(false);
    }
  }, [perPage, page]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="pt-[12px]">
      <Form
        form={form}
        onFinish={() => {
          setPage(1);
          fetchData();
        }}
      >
        <div className="flex">
          <Form.Item name="search" className="w-[200px] mr-2">
            <Input
              placeholder="内容を入力して検索する"
              className="!border-[#D9D9D9] h-[35px]"
            />
          </Form.Item>
          <Form.Item name="rangeValue" className="mr-2">
            <RangePicker className="!border-[#D9D9D9] h-[35px]" />
          </Form.Item>
          <Form.Item name="category" className="mr-2">
            <StyledSelect
              allowClear
              placeholder="カテゴリー"
              options={notificationCategoryOptions}
            />
          </Form.Item>
          <ButtonSolid type="submit">検索</ButtonSolid>
        </div>
      </Form>

      <CustomPagination
        current={page}
        setCurrent={setPage}
        total={totalItems}
        perPage={perPage}
        setPerPage={setPerPage}
        pageSizeOptions={[10, 20, 50]}
      />

      <ul className="mb-4">
        {notiData.map((item) => {
          return (
            <div
              className="flex border-t border-b border-solid border-[#00000026] px-[15px] py-[8px]"
              key={item.id}
            >
              <div className="mr-[100px] w-[350px]">
                <p className="font-semibold">
                  {item.notification_category?.name}
                </p>
                <p>
                  <span className="text-[#0000008C]">作成日:</span>{" "}
                  {item.created_at}
                </p>
              </div>
              <div className="w-[500px]">
                <p>{item.content}</p>
              </div>
            </div>
          );
        })}
      </ul>
      <CustomPagination
        current={page}
        setCurrent={setPage}
        total={totalItems}
        perPage={perPage}
        setPerPage={setPerPage}
        pageSizeOptions={[10, 20, 50]}
      />
    </div>
  );
};

export default Conveyed;
